// extracted by mini-css-extract-plugin
export default {"root":"Input_root__HrSva","top":"Input_top__WT84z","label":"Input_label__cJ9i-"};